import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'

export interface IWidgetFormatter {
    format(data: any): object
}

export class WidgetFormatter implements IWidgetFormatter {

    public format(data: any): object {
        const obj: any = {}
        if (data && data.storyPos) {
            obj[key.WDGT_STORY_POS] = String(data.storyPos)
        }
        return {
            ...obj,
            ...this.formatStory(data.story),
            ...this.formatWdgt(data.wdgt),
            ...this.formatFeed(data.feed),
            ...this.formatVideo(data.video)
        }
    }

    public formatStory(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.id) {
                obj[key.WDGT_CLCKD_STORY_ID] = String(data.id)
            }
            if (data.title) {
                obj[key.WDGT_CLCKD_STORY_TITLE] = String(data.title)
            }
        }
        return obj
    }

    public formatVideo(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.id) {
                obj[key.WDGT_VID_ID] = String(data.id)
            }
            if (data.type) {
                obj[key.WDGT_VID_PLTFRM] = String(data.type)
            }
            if (data.playlistId) {
                obj[key.WDGT_VID_PLYLST_ID] = String(data.playlistId)
            }
            if (data.playlistWdgtId) {
                obj[key.WDGT_VID_PLYLST_WDGT_ID] = String(data.playlistWdgtId)
            }
        }
        return obj
    }

    public formatWdgt(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.name) {
                obj[key.WDGT_NAME] = String(data.name)
            }
            if (data.pos) {
                obj[key.WDGT_POS] = String(data.pos)
            }
            if (data.type) {
                obj[key.WDGT_TYPE] = String(data.type)
            }
            if (data.feed) {
                obj[key.WDGT_FEED] = String(data.feed)
            }
        }
        return obj
    }

    public formatFeed(data: any): object {
        const obj: any = {}
        if (data) {
            obj[key.WDGT_FEED_NAME] = data
                    .filter((item: any) => item.name)
                    .map((item: any) => item.name).join(', ')

            obj[key.WDGT_FEED_ID] = data
                    .filter((item: any) => item.id)
                    .map((item: any) => item.id).join(', ')

            obj[key.WDGT_FEED_TYPE] = data
                    .filter((item: any) => item.type)
                    .map((item: any) => item.type).join(', ')

            obj[key.WDGT_FEED_POS] = data
                    .filter((item: any) => item.pos)
                    .map((item: any) => item.pos).join(', ')
        }
        return obj
    }
}
